// @flow

import React from 'react';
import styled from 'styled-components';
import { ifProp } from 'styled-tools';

import WidthContainer from '../WidthContainer';

const Wrapper = styled.div`
  padding: ${ifProp('noPadding', '0', '60px 0')};
  width: 100%;
`;

const Body = ({
  children,
  noPadding,
  maxWidth,
}: {
  children?: any,
  noPadding: boolean,
  maxWidth: string,
}) => (
  <Wrapper noPadding={noPadding}>
    <WidthContainer maxWidth={maxWidth} noPadding={noPadding}>
      {children}
    </WidthContainer>
  </Wrapper>
);

export default Body;



// WEBPACK FOOTER //
// ./src/components/Body/index.js